import * as React from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/Button';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon, title, description, action, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 p-8 text-center dark:border-gray-700 dark:bg-gray-900/50',
          className
        )}
        role="status"
        aria-live="polite"
      >
        {icon && (
          <div className="mb-4 text-gray-400 dark:text-gray-600" aria-hidden="true">
            {icon}
          </div>
        )}
        <h3 className="mb-2 text-lg font-semibold text-text-primary">
          {title}
        </h3>
        {description && (
          <p className="mb-4 max-w-sm text-sm text-text-secondary">
            {description}
          </p>
        )}
        {action && (
          <Button onClick={action.onClick} variant="primary">
            {action.label}
          </Button>
        )}
      </div>
    );
  }
);

EmptyState.displayName = 'EmptyState';
